(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-text"] && !Shopify.designMode) return;
  try {
    
  // Declaro las variables para sobreescribirlas despues y poder utilizarlas en todo el bloque
  let section_id = ''
  let percent_tl = ''
  let px_tl = ''
  let percent_tr = ''
  let px_tr = ''
  let percent_br = ''
  let px_br = ''
  let percent_bl = ''
  let px_bl = ''
  let color_tl = ''
  let color_tr = ''
  let color_br = ''
  let color_bl = ''

  // Busco todas las veces que se encuetra esta clase al momento de renderizar
  const sections = document.querySelectorAll(".triangle_exist");
  
  // Itero sobre todas les veces que encontre la clase y por cada clase encontrada ejecuto la funcion updateContainerWidth()
  repeatSections()
  function repeatSections() {
    sections.forEach((el) => {
      section_id = el.id?.replace('section_id_', '');
      updateContainerWidth();
    });
  };

  // Esta funcion se ejecuta por cada seccion encontrada lo que indica la funcion anterior
  function updateContainerWidth() {
    const newContainerWidth = calculateContainerWidth();
  
    const WidthPixels_tl = (newContainerWidth * percent_tl) / 100;
    const triangle_tl = document.getElementById(`triangle_tl_${section_id}`);
    if (triangle_tl) triangle_tl.style.borderWidth = `0 0 ${px_tl}px ${WidthPixels_tl}px`;
    if (triangle_tl) triangle_tl.style.borderColor = `transparent transparent transparent ${color_tl}`;

    const WidthPixels_tr = (newContainerWidth * percent_tr) / 100;
    const triangle_tr = document.getElementById(`triangle_tr_${section_id}`);
    if (triangle_tr) triangle_tr.style.borderWidth = `0 ${WidthPixels_tr}px ${px_tr}px 0`;
    if (triangle_tr) triangle_tr.style.borderColor = `transparent ${color_tr} transparent transparent`;

    const WidthPixels_br = (newContainerWidth * percent_br) / 100;
    const triangle_br = document.getElementById(`triangle_br_${section_id}`);
    if (triangle_br) triangle_br.style.borderWidth = `${px_br}px ${WidthPixels_br}px 0 0`;
    if (triangle_br) triangle_br.style.borderColor = `transparent ${color_br} transparent transparent`;    

    const WidthPixels_bl = (newContainerWidth * percent_bl) / 100;
    const triangle_bl = document.getElementById(`triangle_bl_${section_id}`);
    if (triangle_bl) triangle_bl.style.borderWidth = `0 ${WidthPixels_bl}px ${px_bl}px 0`;
    if (triangle_bl) triangle_bl.style.borderColor = `transparent transparent ${color_bl} transparent`;
  }
  
  function calculateContainerWidth() {
    const container = document.getElementById(`shopify-section-${section_id}`);
    const containerWidth = container.offsetWidth;
    container.childNodes.forEach((el) => {
      if (el.id === 'percent_tl') percent_tl = el.value
      if (el.id === 'px_tl') px_tl = el.value
      if (el.id === 'percent_tr') percent_tr = el.value
      if (el.id === 'px_tr') px_tr = el.value
      if (el.id === 'percent_br') percent_br = el.value
      if (el.id === 'px_br') px_br = el.value
      if (el.id === 'percent_bl') percent_bl = el.value
      if (el.id === 'px_bl') px_bl = el.value
      if (el.id === 'color_tl') color_tl = el.value
      if (el.id === 'color_tr') color_tr = el.value
      if (el.id === 'color_br') color_br = el.value
      if (el.id === 'color_bl') color_bl = el.value
    })
    return containerWidth;
  }

  window.addEventListener('resize', repeatSections);
  

  } catch(e) { console.error(e); }
})();
})();
